import * as type from "../../types/API/demoQueryType";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getDemoQueryDataReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.GET_REQUEST_DEMO_QUERY_DATA:
      return {
        ...state,
        loading: true,
      };
    case type.GET_REQUEST_DEMO_QUERY_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_REQUEST_DEMO_QUERY_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addDemoQueryDataReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.ADD_REQUEST_DEMO_QUERY_DATA:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.ADD_REQUEST_DEMO_QUERY_DATA_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.ADD_REQUEST_DEMO_QUERY_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
